module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "75%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/04_intro#h2"
    }
  }, [_vm._v("Introduction and Acknowledgements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/05_fm02#h3"
    }
  }, [_vm._v("Visiting Military Cemeteries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/17_fm03#h4"
    }
  }, [_vm._v("Historical Context")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/32_fm04#h5"
    }
  }, [_vm._v("Visiting the Area")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "top",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/38_chapter01#h6"
    }
  }, [_vm._v("Route 1:")])]), _vm._v(" "), _c('td', {
    staticClass: "top",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/38_chapter01#h6"
    }
  }, [_vm._v("Bois-Grenier")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 2:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neuve Chapelle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter03#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 3:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter03#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aubers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter04#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 4:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter04#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fromelles and Pheasant Wood")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/127_chapter05#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 5:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/127_chapter05#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rue du Bois and the Cinder Track")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/142_chapter06#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 6:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/142_chapter06#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Festubert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/154_chapter07#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 7:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/154_chapter07#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Northern Car Tour")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/192_chapter08#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 8:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/192_chapter08#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cuinchy and the Brickstacks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/213_chapter09#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 9:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/213_chapter09#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hohenzollern Redoubt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/231_chapter10#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 10:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/231_chapter10#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lone Tree and the Dump")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/250_chapter11#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 11:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/250_chapter11#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hill 70")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/265_chapter12#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 12:")])]), _vm._v(" "), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/265_chapter12#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loos Battlefield Car Tour")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "top",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/289_reading#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c438d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_contents.vue
// module id = 66
// module chunks = 0